import React from 'react'

import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'

import TextField from '@material-ui/core/TextField'
import MaskedInput from 'react-text-mask'
import PropTypes from 'prop-types'
import * as yup from 'yup'
import { validateDateFormat, minAgeCheck, maxAgeCheck } from '../../helpers/date-operations'
import qs from 'qs'
import { countryList } from '../../helpers/country-code'
import countries from 'country-list'
import InputMask from 'react-input-mask'

function dateMaskOnChange(event) {
  const caret = event.target.selectionStart
  const element = event.target
  window.requestAnimationFrame(() => {
    element.selectionStart = caret
    element.selectionEnd = caret
  })
}

function DateMask(props) {
  const { inputRef, ...other } = props

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null)
      }}
      mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      placeholder={'MM/DD/YYYY'}
      guide
    />
  )
}
DateMask.propTypes = {
  inputRef: PropTypes.any
}

function renderTextField(helperData, fieldName, label, className = 'm-x5', required = true, isDisabled = false) {
  const { errors, payload, setPayload, t } = helperData
  label = label || t(fieldName)
  return (
    <TextField
      label={label}
      id={fieldName}
      className={className}
      value={payload[fieldName]}
      onChange={(e) => setPayload({ ...payload, [fieldName]: e.target.value })}
      error={errors[fieldName] !== undefined}
      helperText={errors[fieldName]}
      required={required}
      disabled={!!isDisabled}
    />
  )
}

function renderField(helperData, fieldModel, fieldModelUpdated) {
  const { errors, payload, setPayload, t } = helperData
  const hiddenField = fieldModel.hidden
  const label = fieldModel.label ? t(fieldModel.label) : t(fieldModelUpdated[fieldModel.fieldName])
  let fieldLabel = label
  if (fieldModel.label === 'emailOptIn') {
    fieldLabel = label.split('Polaris Family of Brands')
  }

  switch (fieldModel.type) {
    case 'string':
      if (!hiddenField) {
        const selectErrorsStyle =
          (errors.postalCode || errors.state || errors.driversLicenseState || errors.birthDate) &&
          !errors.driversLicenseCountry &&
          !errors.country
            ? {
                paddingBottom: '1.5rem'
              }
            : {}

        if (fieldModel.enum === 'country') {
          return (
            <FormControl error={errors[fieldModel.fieldName]} style={selectErrorsStyle} className={fieldModel.className}>
              <Select
                id="country-select-1"
                value={payload[fieldModel.fieldName]}
                onChange={(e) => setPayload({ ...payload, [fieldModel.fieldName]: e.target.value })}
              >
                <MenuItem value={'none'}>
                  <em>{t('selectCountry')}</em>
                </MenuItem>
                {countryList.map((o, index) => (
                  <MenuItem key={`country-${index}`} value={countries.getCode(o)}>
                    {o}
                  </MenuItem>
                ))}
              </Select>
              {errors[fieldModel.fieldName] && <FormHelperText>{t('required')}</FormHelperText>}
            </FormControl>
          )
        } else if (fieldModel.fieldName === 'phone') {
          return (
            <TextField
              label={label}
              id={fieldModel.fieldName}
              className={fieldModel.className}
              value={payload[fieldModel.fieldName]}
              onChange={(e) => setPayload({ ...payload, [fieldModel.fieldName]: e.target.value })}
              error={errors[fieldModel.fieldName] !== undefined}
              helperText={errors[fieldModel.fieldName]}
              required={fieldModel.required}
              disabled={fieldModel.readonly}
              InputProps={{
                ...(payload[fieldModel.fieldName]
                  ? { inputComponent: InputMask, inputProps: { mask: '(999) 999-9999', maskChar: ' ' } }
                  : {})
              }}
            />
          )
        } else if (fieldModel.fieldName === 'driversLicense') {
          const handleDriverLicenseInput = (e) => {
            const value = e.target.value.trimStart()
            setPayload({ ...payload, [fieldModel.fieldName]: value })
          }

          return (
            <TextField
              label={label}
              id={fieldModel.fieldName}
              className={fieldModel.className}
              value={payload[fieldModel.fieldName]}
              onChange={(e) => handleDriverLicenseInput(e)}
              error={errors[fieldModel.fieldName] !== undefined}
              helperText={errors[fieldModel.fieldName]}
              required={fieldModel.required}
              disabled={fieldModel.readonly}
            />
          )
        } else {
          return (
            <TextField
              label={label}
              id={fieldModel.fieldName}
              className={fieldModel.className}
              value={payload[fieldModel.fieldName]}
              onChange={(e) => setPayload({ ...payload, [fieldModel.fieldName]: e.target.value })}
              error={errors[fieldModel.fieldName] !== undefined}
              helperText={errors[fieldModel.fieldName]}
              required={fieldModel.required}
              disabled={fieldModel.readonly}
            />
          )
        }
      }
      break
    case 'date':
      if (!hiddenField) {
        return (
          <TextField
            label={label}
            id={fieldModel.fieldName}
            className={fieldModel.className}
            value={payload[fieldModel.fieldName]}
            onChange={(e) => {
              setPayload({ ...payload, [fieldModel.fieldName]: e.target.value }, () => dateMaskOnChange(e))
            }}
            error={errors[fieldModel.fieldName] !== undefined}
            helperText={errors[fieldModel.fieldName]}
            required={fieldModel.required}
            InputProps={{ inputComponent: DateMask }}
          />
        )
      }
      break
    case 'boolean':
      if (!hiddenField) {
        return (
          <FormControl
            error={errors[fieldModel.fieldName] !== undefined}
            className={fieldModel.className}
            key={fieldModel.fieldName}
            style={{ margin: '.5rem' }}
          >
            <FormControlLabel
              label={
                <span className={fieldModel.labelClassName}>
                  {label.startsWith('Sign me up') ? (
                    <>
                      {fieldLabel[0]}
                      <a href="https://www.polaris.com/en-us/brands/" target="_blank" rel="noreferrer">
                        Polaris Family of Brands
                      </a>
                      {fieldLabel[1]}
                    </>
                  ) : (
                    label
                  )}
                </span>
              }
              control={
                <Checkbox
                  color="primary"
                  checked={payload[fieldModel.fieldName]}
                  onChange={(e) => setPayload({ ...payload, [fieldModel.fieldName]: e.target.checked })}
                />
              }
            />
            <FormHelperText className="mt-0 up-x5 mb-x5">{errors[fieldModel.fieldName]}</FormHelperText>
          </FormControl>
        )
      }
      break
    default:
      return <div />
  }
}

function renderDateField(helperData, fieldName, label, className = 'm-x5', required = false) {
  const { errors, payload, setPayload, t } = helperData
  label = label || t(fieldName)
  return (
    <TextField
      label={label}
      id={fieldName}
      className={className}
      value={payload[fieldName]}
      onChange={(e) => {
        setPayload({ ...payload, [fieldName]: e.target.value }, () => dateMaskOnChange(e))
      }}
      error={errors[fieldName] !== undefined}
      helperText={errors[fieldName]}
      required={required}
      InputProps={{ inputComponent: DateMask }}
    />
  )
}

function renderCheckField(helperData, fieldName, label, className = 'm-x5') {
  const { errors, payload, setPayload, t } = helperData
  label = label || t(fieldName)
  return (
    <FormControl error={errors[fieldName] !== undefined} className={className} key={label || fieldName}>
      <FormControlLabel
        label={label}
        control={
          <Checkbox
            color="primary"
            checked={payload[fieldName]}
            onChange={(e) => setPayload({ ...payload, [fieldName]: e.target.checked })}
          />
        }
      />
      <FormHelperText className="mt-0 up-x5 mb-x5 pb-1">{errors[fieldName]}</FormHelperText>
    </FormControl>
  )
}

function renderParticipantField(
  helperData,
  fieldName,
  index,
  label,
  className = 'm-x5',
  isCheckbox = false,
  disabled,
  fieldModel
) {
  const { errors, payload, setPayload, t } = helperData
  const { participants } = payload
  const hiddenField = fieldModel === undefined

  label = label || t(fieldName)
  const value = participants[index][fieldName]
  const pathName = `participants[${index}].${fieldName}`
  const onChange = (val) => {
    participants[index][fieldName] = val
    setPayload({ ...payload, participants })
  }
  if (!hiddenField) {
    if (isCheckbox) {
      return (
        <FormControlLabel
          id={fieldName + index}
          className="no-flex no-wrap down-1 m-x5"
          label={label}
          disabled={!disabled}
          control={<Checkbox color="primary" checked={value} onChange={(e) => onChange(e.target.checked)} />}
        />
      )
    } else {
      return (
        <TextField
          label={label}
          id={fieldName + index}
          fullWidth
          className={className}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          error={errors[pathName] !== undefined}
          helperText={errors[pathName]}
        />
      )
    }
  }
}

function renderEmailTextField(readOnly) {
  return this.renderTextField('Email', 'm-x5', 'email', true, readOnly)
}

const birthDateValidation = yup
  .mixed()
  .required('Required')
  .test({
    name: 'format',
    message: 'Date Must be in mm/dd/yyyy format',
    test: (val) => validateDateFormat(val)
  })
  .test({
    name: 'Under 18',
    message: 'Primary Rider Must be older than 18',
    test: (val) => (validateDateFormat(val) ? minAgeCheck(val, 18) : false)
  })
  .test({
    name: 'Invalid Date',
    message: 'Please Use Valid Date',
    test: (val) => (validateDateFormat(val) ? maxAgeCheck(val) : false)
  })

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const phoneNewRegExp = /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/

async function validate(validation, payload) {
  const errors = {}
  try {
    await validation.validate(payload, { abortEarly: false })
  } catch (err) {
    err.inner = err.inner || []
    for (const error of err.inner) {
      errors[error.path] = errors[error.path] || error.message
    }
  }
  return errors
}

function isDebug() {
  const wl = window.location
  return wl.hostname === 'localhost' && wl.search.includes('debug=1')
}

const qpMap = {
  contact: [
    'firstName',
    'lastName',
    'email',
    'phone',
    'addressLine1',
    'addressLine2',
    'city',
    'state',
    'postalCode',
    'country',
    'birthDate'
  ],
  license: ['driversLicenseState', 'driversLicenseCountry', 'driversLicense', 'birthDate']
}

const queryParams = qs.parse(window.location.search.replace(/^\?/, ''))

function preparePayload(passengerNumber, waiverDataObject, waiverModel) {
  const res = { participants: { isEhs: false, participants: [] } }
  Object.keys(qpMap).forEach((k) => {
    let paramKey = k === 'contact' ? 'contactInfo' : 'driverLicenseInfo'
    res[k] = qpMap[k].reduce((acc, v) => {
      if (waiverModel[paramKey]) {
        acc[v] = waiverModel[paramKey][v].initialValue
      }
      return acc
    }, {})
  })
  res.contact.country = res.contact.country || 'US'
  res.license.driversLicenseCountry = res.license.driversLicenseCountry || 'US'
  const createParticipant = () => ({ firstName: '', lastName: '', isUnder18: false })
  for (let i = 0; i < passengerNumber; i++) {
    res.participants.participants.push(createParticipant())
  }
  if (checkParticipantsModel(waiverModel.minorsInfo)) {
    for (let i = 0; i < passengerNumber; i++) {
      if (waiverModel.minorsInfo.participants[i]) {
        res.participants.participants[i].firstName = waiverModel.minorsInfo.participants[i].firstName.initialValue
        res.participants.participants[i].lastName = waiverModel.minorsInfo.participants[i].lastName.initialValue
      }
      if (waiverModel.minorsInfo.participants[i].isUnder18.hidden) {
        delete res.participants.participants[i].isUnder18
      }
    }
    res.contact.firstName = ''
    res.contact.lastName = ''
  }
  if (checkAdultModel(waiverModel.contactInfo)) {
    res.contact.firstName = waiverModel.contactInfo.firstName.initialValue
    res.contact.lastName = waiverModel.contactInfo.lastName.initialValue
  }
  return res
}

function checkParticipants(waiverDataObject) {
  if (waiverDataObject && waiverDataObject.minors && waiverDataObject.minors.length > 0) {
    return true
  }
  return !!waiverDataObject.isParticipantMinor
}

function checkParticipantsModel(waiverDataObject) {
  if (waiverDataObject && waiverDataObject.participants && waiverDataObject.participants.length > 0) {
    for (let i = 0; i < waiverDataObject.participants.length; i++) {
      if (waiverDataObject.participants[i].firstName || waiverDataObject.participants[i].firstName) {
        return true
      }
    }
  }
  return false
}

function checkAdultModel(waiverDataObject) {
  if (waiverDataObject && waiverDataObject.adult && waiverDataObject.adult.firstName) {
    return true
  }
  if (waiverDataObject && waiverDataObject.firstName) {
    return true
  }
  return false
}

export {
  renderTextField,
  renderDateField,
  renderCheckField,
  renderParticipantField,
  renderEmailTextField,
  birthDateValidation,
  phoneRegExp,
  phoneNewRegExp,
  validate,
  isDebug,
  preparePayload,
  queryParams,
  checkParticipants,
  renderField
}
